/*
   This function will return an dictionary 
   which indicates which column will have an extra item
   {1:false,2:true,3:false}
*/
const calculateIndexMap = (extra, middle) => {
  
    if (extra <= 0) return {};
    let map = {};
    let left = middle - 1;
    let right = middle + 1;
    map[middle] = true;
    extra = extra - 1;
    while (extra) {
      map[left] = true;
      extra = extra - 1;
      left = left - 1;
      if (extra) {
        map[right] = true;
        extra = extra - 1;
        right = right +1;
      }
    }
    return map;
  };

  export default calculateIndexMap  